import { Answer } from './Answer.model';
import { TRCFundClasses } from './tRCFundClasses.model';
export class TRCForms {
    
    trcFundClasses : any
    trcPLCForm = JSON.parse(sessionStorage.getItem("TRCPLCForm") ?? "[]") ;
    trcFREForm  = JSON.parse(sessionStorage.getItem("TRCFREForm") ?? "[]") ;
    trcTBCForm = JSON.parse(sessionStorage.getItem("TRCTBCForm") ?? "[]") ;
}